import React from 'react';
import styled from 'styled-components';
import { SectionTitle, Section, SectionBlock } from './TwoColumnLayout';
import { RadioButtons } from './RadioButtons';
import { Switch } from './SettingRow';
import { PhoneDirectoryUserInfo } from '../containers/SimsInfoPage/PhoneDirectoryUserInfo';
import { PhoneDirectoryOwnerInfo } from '../containers/SimsInfoPage/PhoneDirectoryOwnerInfo';

// TODO ActivationSimSettings page has a component with similar functionality, can we use this component there?

// TODO should we merge handlePhoneDirectoryPrivacy, simClientInfoChangeHandler and onChane?
interface Props {
	disabled: boolean;
	privacy: any;
	handlePhoneDirectoryPrivacy: (value: string) => void;
	showErrors: boolean;
	phoneDirectoryUserInfo: any;
	simClientInfoChangeHandler: (field: string, value: string) => void;
	phoneDirectoryPrivacy: any;
	includeOwnerInfo: boolean;
	phoneDirectoryOwnerInfo: any;
	onChange: (value: any) => void;
	checked: boolean;
}

const SubTitle = styled.p`
	font-size: 1.3rem;
`;

const radioButtonValues = [
	{ displayName: 'Salainen numero', buttonId: 'private-number', displaytext: 'Puhelinnumero ei näy puhelun vastaanottajalle, eikä numeropalveluissa.' },
	{ displayName: 'Puolisalainen numero', buttonId: 'semi-private-number', displaytext: 'Puhelinnumero näkyy puhelun vastaanottajalle, mutta ei numeropalveluissa.' },
	{ displayName: 'Julkinen numero', buttonId: 'public-number', displaytext: 'Puhelinnumero näkyy numeropalveluissa ja puhelun vastaanottajalle.' }
];

export const SubscriptionPrivacyForm: React.FC<Props> = (props: Props) => {
	return (
		<React.Fragment>
			<SectionTitle>Puhelinnumeron julkisuus</SectionTitle>
			<Section>
				<SectionBlock>
					<RadioButtons
						disabled={props.disabled}
						updating={props.privacy.updating}
						onChange={props.handlePhoneDirectoryPrivacy}
						name={'privacy'}
						currentValue={props.phoneDirectoryPrivacy}
						values={radioButtonValues}
					/>
					<SubTitle>Numeropalveluissa näkyvät tiedot</SubTitle>
					<PhoneDirectoryUserInfo onChange={props.simClientInfoChangeHandler} phoneDirectoryUserInfo={props.phoneDirectoryUserInfo} showErrors={props.showErrors} disabled={props.disabled} />
					{props.includeOwnerInfo && (
						<React.Fragment>
							<Switch
								title="Yrityksen tiedot voi näyttää numeroni ohessa"
								disabled={props.disabled || Boolean(props.phoneDirectoryUserInfo.publishOwnerUpdating)}
								infoText={'Asetusta päivitetään, tämä voi viedä muutaman minuutin'}
								checked={props.checked}
								onChange={(value: string) => props.onChange({ usePhoneDirectoryOwner: { name: 'usePhoneDirectoryOwner', value } })}
							/>
							<PhoneDirectoryOwnerInfo phoneDirectoryOwnerInfo={props.phoneDirectoryOwnerInfo} />
						</React.Fragment>
					)}
				</SectionBlock>
			</Section>
		</React.Fragment>
	);
};
